import { render } from "./Footer.vue?vue&type=template&id=aff2c0d6&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=aff2c0d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aff2c0d6"

export default script